import { useCallback, useEffect, useState } from "react";

/** Seconds left before an action may run again (the resend button). Starts running when the screen opens. */
export function useCooldown(seconds: number): { left: number; restart(): void } {
  const [until, setUntil] = useState(() => Date.now() + seconds * 1000);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (until <= now) return;
    const timer = setTimeout(() => setNow(Date.now()), Math.min(1000, until - now));
    return () => clearTimeout(timer);
  }, [until, now]);
  const restart = useCallback(() => { const at = Date.now(); setNow(at); setUntil(at + seconds * 1000); }, [seconds]);
  return { left: Math.max(0, Math.ceil((until - now) / 1000)), restart };
}
